<template>
	<div v-if="show" class="modal-overlay">
		<div class="modal">
			<h2 class="title">🚨 Tentative de triche détéctée</h2>
			<p class="description">
				Nous avons remarqué que tu as changé d'onglet dans ton navigateur, ce qui peut être interprété comme une
				tentative de triche.
			</p>

			<div class="siren-container">
				<img src="@/assets/images/siren.png" alt="Siren" class="siren-image" />
			</div>

			<p class="notification-message">Une notification vient d'être envoyée à l'administrateur</p>

			<div class="modal-buttons">
				<button @click="close">J'ai compris, je me concentre</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WaningOutOfTestFocusModal',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
}

.modal {
	background: white;
	padding: 30px;
	border-radius: 8px;
	text-align: center;
	max-width: 500px;
	width: 100%;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.title {
	color: #ff3b30;
	font-size: 24px;
	margin-bottom: 20px;
	font-weight: bold;
}

.description {
	font-size: 18px;
	margin-bottom: 30px;
	line-height: 1.4;
	font-weight: bold;
}

.siren-container {
	background-color: #ffe0e0;
	border-radius: 25%;
	width: 150px;
	height: 150px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto 20px;
}

.siren-image {
	width: 90px;
	height: auto;
}

.notification-message {
	color: #ff3b30;
	font-size: 16px;
	margin-bottom: 30px;
}

.modal-buttons button {
	margin: 5px;
	padding: 15px 20px;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	background-color: #222;
	color: white;
	font-size: 16px;
	width: 100%;
}

@media only screen and (max-width: 600px) {
	.modal {
		background: white;
		padding: 20px;
		border-radius: 8px;
		text-align: center;
		max-width: 100%;
		width: 90%;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
	}

	.siren-container {
		width: 120px;
		height: 120px;
	}

	.siren-image {
		width: 60px;
	}
}
</style>
